import type {
  EmailTemplateAttributes as GQLTemplateInput,
  EmailTemplate as GQLItem,
} from '../../generated/api.graphql';
import { take } from '../../util/takePayload';

export type EmailTemplateAttributes = {
  id?: number;
  templateName: string;
  subject: string;
  content: string;
  bcc?: string[];
  templateType: 'WILL_CALL';
};

export type EmailTemplate = {
  id: number;
  templateName: string;
  subject: string;
  content: string;
  bcc?: string[];
  templateType: 'WILL_CALL';
};

export const toGqlInput = (gqlInput: EmailTemplateAttributes): GQLTemplateInput =>
  take(gqlInput, 'id', 'templateName', 'subject', 'content', 'bcc', 'templateType');

export const fromGql = (item: GQLItem): EmailTemplate =>
  take(item, 'id', 'templateName', 'subject', 'content', 'bcc', 'templateType');

export const fromGqlCollection = (items: GQLItem[]): EmailTemplate[] =>
  items.map(fromGql);
